// /Users/stuartmcgeer/portalworx/frontend/src/index.tsx

import './index.css';  // Load application-specific styles
import './styles/global/GlobalStyles.css';  // Load global styles for consistent design across the app
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';  // Main application component
import reportWebVitals from './reportWebVitals';  // Performance measurement utility

// Create the root element and render the app within React's strict mode
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Measure and report web performance, logging results to the console
reportWebVitals(console.log);
